module.exports = __webpack_public_path__ + "static/media/cloudy.ad789581.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/cloudy.svg
// module id = 516
// module chunks = 0